



import { Vue, Component } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
@Component({
  components: { AdminIframe },
})
export default class PartnerRegisterNewIframe extends Vue {
  private remoteSrc = '';

  private setRemoteSrc() {
    const { query } = this.$route;
    const queryObject = { ...query, serviceType: 'PRO' };
    const queryString = new URLSearchParams(queryObject).toString();
    this.remoteSrc = process.env.VUE_APP_ADMIN_REMOTE_URL + '/configuration/partner/registration/new?' + queryString;
  }

  created() {
    this.setRemoteSrc();
  }
}
